import styled from "styled-components";

export const HeroCardWrapper = styled.div`
  position: relative;
  z-index: 5;
  @media screen and (max-width: 768px) {
    /* releated to "things i love" section bug */
    margin-top: 90px;
  }
`;

export const CodeCardWrapper = styled.div`
  padding: 30px 35px;
  border-radius: 10px;
  background-color: ${(props) =>
    props.props === "dark" ? "rgb(35, 35, 35)" : "white"};
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.05);
  pre {
    font-size: 1rem;
    color: ${(props) =>
      props.props === "dark" ? "#fff" : "rgb(109, 131, 242)"};
    font-weight: ${(props) => (props.props === "dark" ? "normal" : "bold")};
  }
  pre {
    line-height: 2rem;
  }
  @media screen and (max-width: 700px) {
    pre {
      text-align: left;
      font-size: 0.8rem;
      word-wrap: break-word;
    }
  }
`;
